import { render, staticRenderFns } from "./WF5_ValidateEmail.vue?vue&type=template&id=5fe4f53a"
import script from "./WF5_ValidateEmail.vue?vue&type=script&lang=js"
export * from "./WF5_ValidateEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports